// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZHrK","left":"styles_left__28d6B"};